import NBType, { InferType } from '@netbase/nb-type'
import AnalysisType from '../enums/AnalysisType'
import AnnotationDisplayMode from '../enums/AnnotationDisplayMode'
import AuthorSchema from './AuthorSchema'
import AuthorTypeGroup from '../enums/AuthorTypeGroup'
import CVLogoSchema from './CVLogoSchema'
import DayHourSchema from './DayHourSchema'
import Followers from '../enums/Followers'
import Gender from '../enums/Gender'
import GeoDisplaySchema from './GeoDisplaySchema'
import GeoFencingSchema from './GeoFencingSchema'
import Interest from '../enums/Interest'
import Language from '../enums/Language'
import LxnxFilterSchema from './LxnxFilterSchema'
import MeasureType from '../enums/MeasureType'
import MeasurementFilterSchema from './MeasurementFilterSchema'
import MediaType from '../enums/MediaType'
import OrganicPaidPostType from '../enums/OrganicPaidPostType'
import OwnedEarned from '../enums/OwnedEarned'
import PostSchema from './PostSchema'
import PostTypeGroup from '../enums/PostTypeGroup'
import Precision from '../enums/Precision'
import Profession from '../enums/Profession'
import ScopedStringListSchema from './ScopedStringListSchema'
import Sentiment from '../enums/Sentiment'
import SentimentDriverSchema from './SentimentDriverSchema'
import SocialWebChannelSchema from './SocialWebChannelSchema'
import Source from '../enums/Source'
import ThemeInfoListSchema from './ThemeInfoListSchema'
import TimeInterval from '../enums/TimeInterval'
import TopicInfoSchema from './TopicInfoSchema'
import VerifiedUsers from '../enums/VerifiedUsers'
import WidgetType from '../enums/WidgetType'

const SocialWebSummaryMetricsCompactWidgetSchema = NBType.object().shape(
  'SocialWebSummaryMetricsCompactWidgetSchema',
  {
    /* @prop */
    analysisType: NBType.enum(AnalysisType),
    /* @prop */
    annotations: NBType.array().of(NBType.enum(AnnotationDisplayMode)),
    /* @prop */
    authorTypeGroups: NBType.array().of(NBType.enum(AuthorTypeGroup)),
    /* @prop */
    cvLogos: NBType.array().of(CVLogoSchema),
    /* @prop */
    dayHours: NBType.array().of(DayHourSchema),
    /* @prop */
    endDatetime: NBType.number(),
    /* @prop */
    excludedAuthors: NBType.array().of(AuthorSchema),
    /* @prop */
    excludedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    excludedChannels: NBType.array().of(SocialWebChannelSchema),
    /* @prop */
    excludedDomains: NBType.array().of(NBType.string()),
    /* @prop */
    excludedEmojis: NBType.array().of(NBType.string()).nullable(),
    /* @prop */
    excludedGeographies: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    excludedGeographiesSummary: NBType.array().of(NBType.array().of(GeoDisplaySchema)),
    /* @prop */
    excludedInterests: NBType.array().of(NBType.enum(Interest)),
    /* @prop */
    excludedLanguages: NBType.array().of(NBType.enum(Language)),
    /* @prop */
    excludedPosts: NBType.array().of(NBType.array().of(PostSchema)),
    /* @prop */
    excludedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    excludedProfessions: NBType.array().of(NBType.enum(Profession)),
    /* @prop */
    excludedSentimentDriver: SentimentDriverSchema,
    /* @prop */
    excludedTerms: NBType.array().of(ScopedStringListSchema),
    /* @prop */
    excludedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    followers: NBType.array().of(NBType.enum(Followers)),
    /* @prop */
    genders: NBType.array().of(NBType.enum(Gender)),
    /* @prop */
    geoFencings: NBType.array().of(NBType.array().of(GeoFencingSchema)),
    /* @prop */
    includedAuthors: NBType.array().of(AuthorSchema),
    /* @prop */
    includedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    includedChannels: NBType.array().of(SocialWebChannelSchema),
    /* @prop */
    includedDomains: NBType.array().of(NBType.string()),
    /* @prop */
    includedEmojis: NBType.array().of(NBType.string()).nullable(),
    /* @prop */
    includedGeographies: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    includedGeographiesSummary: NBType.array().of(NBType.array().of(GeoDisplaySchema)),
    /* @prop */
    includedInterests: NBType.array().of(NBType.enum(Interest)),
    /* @prop */
    includedLanguages: NBType.array().of(NBType.enum(Language)),
    /* @prop */
    includedPosts: NBType.array().of(NBType.array().of(PostSchema)),
    /* @prop */
    includedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    includedProfessions: NBType.array().of(NBType.enum(Profession)),
    /* @prop */
    includedSentimentDriver: SentimentDriverSchema,
    /* @prop */
    includedTerms: NBType.array().of(ScopedStringListSchema),
    /* @prop */
    includedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
    /* @prop */
    lxnxFilter: LxnxFilterSchema,
    /* @prop */
    measures: NBType.array().of(NBType.enum(MeasureType)),
    /* @prop */
    mediaTypes: NBType.array().of(NBType.enum(MediaType)),
    /* @prop */
    name: NBType.string(),
    /* @prop */
    netPromoterScores: NBType.array().of(MeasurementFilterSchema),
    /* @prop */
    organicPaidPostTypes: NBType.array().of(NBType.enum(OrganicPaidPostType)),
    /* @prop */
    ownedEarned: NBType.array().of(NBType.enum(OwnedEarned)),
    /* @prop */
    parentAnalysisType: NBType.enum(AnalysisType),
    /* @prop */
    posX: NBType.number(),
    /* @prop */
    posY: NBType.number(),
    /* @prop */
    postTypeGroups: NBType.array().of(NBType.enum(PostTypeGroup)),
    /* @prop */
    precision: NBType.enum(Precision),
    /* @prop */
    primaryTerms: NBType.array().of(NBType.string()),
    /* @prop */
    removedInsights: NBType.array().of(NBType.string()),
    /* @prop */
    selectedMeasures: NBType.array().of(NBType.enum(MeasureType)),
    /* @prop */
    selectedTopic: TopicInfoSchema,
    /* @prop */
    sentiments: NBType.array().of(NBType.enum(Sentiment)),
    /* @prop */
    showChange: NBType.boolean(),
    /* @prop */
    sizeX: NBType.number(),
    /* @prop */
    sizeY: NBType.number(),
    /* @prop */
    sources: NBType.array().of(NBType.enum(Source)),
    /* @prop */
    starRatings: NBType.array().of(MeasurementFilterSchema),
    /* @prop */
    startDatetime: NBType.number(),
    /* @prop */
    surveyScores: NBType.array().of(MeasurementFilterSchema),
    /* @prop */
    themeInfos: NBType.array().of(ThemeInfoListSchema),
    /* @prop */
    timeInterval: NBType.enum(TimeInterval),
    /* @prop */
    topicInfos: NBType.array().of(TopicInfoSchema),
    /* @prop */
    type: NBType.enum(WidgetType),
    /* @prop */
    verifiedUsers: NBType.array().of(NBType.enum(VerifiedUsers)),
    /* @prop */
    widgetId: NBType.number()
    /* END */
  }
)
export default SocialWebSummaryMetricsCompactWidgetSchema
export type SocialWebSummaryMetricsCompactWidget = InferType<
  typeof SocialWebSummaryMetricsCompactWidgetSchema
>
// RESERVE BELOW
